import useStore from './_store';
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { usePageStore } from '@/store';
import util from '../../common/util';
import { numberFormat } from '../../common/format';
import { colorBlock } from '../defaultSpacing';

import Tags from '@/components/tags.vue';
import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData } from './asyncData';

export default {
    _getUseStore: useStore,
    i18next: {
        ns: 'md-house-detail'
    },
    asyncData: mapAsyncData(asyncData),
    components: {
        Tags
    },
    data: function() {
        return {
            title: '',
            lotSizeType: 0,
            ...colorBlock
        };
    },
    computed: {
        ...rootMapState(usePageStore, {
            "currencySymbol": store => store.currency.symbol,
            "isCensusSubdivision": store => store.page?.censusSubdivision || false,
            "siteId": "siteId"
        }),
        ...mapState({
            "houseDetailInfo": store => store.houseDetailInfo,
            "countryConfig": store => store.countryConfig
        }),
        
        
        
        isMobileSize() {
            return this.platform.isMobile;
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        },
        isOccupancyHasData() {
            return !!this.houseDetailInfo?.demographics?.households;
        },
        isListingDetailHasData() {
            const list = this.houseDetailInfo?.listingDetail || [];
            return list.some(v => v.average !== '-' || v.median !== '-');
        },
        houseDetails() {
            let { listingDetail = [] } = util.cloneData(this.houseDetailInfo) || {};
            let houseDetails = listingDetail.map(item => {
                const name = item.name;
                let average = Number(item.average),
                    median = Number(item.median);
                if (name.toLowerCase() === 'lot size') {
                    if (this.lotSizeType === 1) {
                        average =
                            average > -1
                                ? average > 10890
                                    ? this.$t('md-house-detail.acres', {
                                        number: numberFormat(
                                            average / 43560,
                                            false,
                                            2
                                        )
                                    })
                                    : this.$t('md-house-detail.sqft', {
                                        number: numberFormat(
                                            average,
                                            false,
                                            0
                                        )
                                    })
                                : '-';
                        median =
                            median > -1
                                ? median > 10890
                                    ? this.$t('md-house-detail.acres', {
                                        number: numberFormat(
                                            median / 43560,
                                            false,
                                            2
                                        )
                                    })
                                    : this.$t('md-house-detail.sqft', {
                                        number: numberFormat(median, false, 0)
                                    })
                                : '-';
                    } else {
                        average =
                            average > -1
                                ? this.$t('md-house-detail.sqft', {
                                    number: numberFormat(average, false, 0)
                                })
                                : '-';
                        median =
                            median > -1
                                ? this.$t('md-house-detail.sqft', {
                                    number: numberFormat(median, false, 0)
                                })
                                : '-';
                    }
                } else if (name.toLowerCase() === 'taxes') {
                    average =
                        average > -1
                            ? `${this.currencySymbol}` +
                              numberFormat(average, false, 0)
                            : '-';
                    median =
                        median > -1
                            ? `${this.currencySymbol}` +
                              numberFormat(median, false, 0)
                            : '-';
                } else if (
                    name.toLowerCase() === 'bedrooms' ||
                    name.toLowerCase() === 'bathrooms'
                ) {
                    average = average > -1 ? Number(average.toFixed(2)) : '-';
                    median = median > -1 ? Number(median.toFixed(2)) : '-';
                } else {
                    average = average > -1 ? average.toFixed(0) : '-';
                    median = median > -1 ? median.toFixed(0) : '-';
                }
                item.average = average;
                item.median = median;
                return item;
            });
            return houseDetails;
        },
        detailEmpty() {
            return !this.houseDetails;
        }
    },
    watch: {
        isAllModuleHasData: {
            immediate: true,
            handler(val) {}
        }
    },
    beforeMount() {
        window?.siteAppVm?.$EventBus.$emit('canadaHouseDetailConfig', {
            siteid: this.siteId,
            flag: this.isOccupancyHasData || this.isListingDetailHasData
        });
    },
    methods: {}
};
